export default {
  DEV: 'dev',
  APP_DATA: 'appData',
};
